import React, { Fragment } from 'react'
import { Typography } from '@klarna/bubble-ui'
import getValueFromNodes from '../../utilities/getValueFromNode'
import { Node } from '../../types'
import { KlarnaBadge } from '../KlarnaBadge/KlarnaBadge'

export default function TimelineHeading({ nodes, step, textToken }: { nodes: Node[]; step: number; textToken?: string }) {
  // eslint-disable-next-line max-len
  const headingProperty = nodes.some(node => node.name.includes('TIMELINE')) ? `TIMELINE_STEP${step}_HEADING` : `CHECKOUT_INFO${step}_HEADING`
  let value = getValueFromNodes(nodes, headingProperty) || ''
  const hasBadge = value.includes('{{badge}}')

  if (hasBadge) {
    value = value.replace('{{badge}}', '')
  }

  return (
    <Fragment>
      <Typography textToken={textToken}>
        {value}
        {hasBadge ? <KlarnaBadge /> : null}
      </Typography>
    </Fragment>
  )
}
